


























import TextSanitized from "@/common/components/atoms/TextSanitized.vue";
import TheL04Header from "@/general/components/pages/parts/WhatsNewDetails/TheL04Header.vue";
import TheL04Pagination from "@/general/components/pages/parts/WhatsNewDetails/TheL04Pagination.vue";
import { Vue, Component } from "vue-property-decorator";
import store from "@/general/store";
import { WhatsNewDetailsModel } from "@/general/store/models";
import { getWhatsNewDetails } from "@/general/store/api";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";

@Component({
  name: "WhatsNewDetails",
  components: {
    TextSanitized,
    TheL04Header,
    TheL04Pagination
  },
  store: store
})
export default class WhatsNewDetails extends Vue {
  whatsNewDetailsModel?: WhatsNewDetailsModel;
  title: string | undefined | null = "";
  content: string | undefined | null = "";
  publishedAt = "";
  updatedAt = "";
  authorName = "";
  authorId = "";
  pk: number | undefined = 0;
  prevNews: any = {
    title: "",
    link: ""
  };
  nextNews: any = {
    title: "",
    link: ""
  };

  breadcrumb = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "お知らせ一覧",
      url: CONST_DATA.SITE_MAP.WHATS_NEW,
      pageType: "lower"
    },
    {
      text: "お知らせ詳細",
      url: "",
      pageType: "lower"
    }
  ];

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  get urlWhatsNewDetail() {
    return CONST_DATA.SITE_MAP.WHATS_NEW_DETAILS;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.getBreadcrumb(this.breadcrumb);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = parseInt(urlParams.get("id") as string);
    await this.whatsNewDetails(id);
  }

  async whatsNewDetails(id: number) {
    const response = await getWhatsNewDetails(id);
    console.log({ response });
    if (!response?.title) {
      window.location.href = "/error-not-found";
      return false;
    }
    this.whatsNewDetailsModel = response;

    if (this.whatsNewDetailsModel) {
      this.title = this.whatsNewDetailsModel.title;
      this.publishedAt = this.$dayjs
        .utc(this.whatsNewDetailsModel.created_at)
        .locale("ja")
        .format("YYYY/MM/DD");
      this.updatedAt = this.$dayjs
        .utc(this.whatsNewDetailsModel.updated_at)
        .locale("ja")
        .format("YYYY/MM/DD");
      this.authorName = this.whatsNewDetailsModel.author_name;
      this.authorId = this.whatsNewDetailsModel.employeeId;
      this.content = this.whatsNewDetailsModel.message;

      this.prevNews.link = `${this.urlWhatsNewDetail}?id=${this.whatsNewDetailsModel.page_details.previous?.url}`;
      this.prevNews.title = this.whatsNewDetailsModel.page_details.previous?.title;
      this.nextNews.link = `${this.urlWhatsNewDetail}?id=${this.whatsNewDetailsModel.page_details.next?.url}`;
      this.nextNews.title = this.whatsNewDetailsModel.page_details.next?.title;
    }
  }
}
